import React, {FC, useCallback, useContext, useEffect} from 'react';
import {Grid} from '@mui/material';
import LocationListItemLink from './LocationListItemLink';
import {generateLocationProfileLink} from '../../../util/LinkUtils';
import {getAllBuyerFavoriteLocations} from "../requests/location-requests";
import {AppContext} from '../../../context/app-context';
import {isBuyerAccountType} from "../../../util/AccountUtils";
import {styled} from "@mui/material/styles";

const LocationListContainer = styled(Grid)(() => ({
  backgroundColor: '#FBFBFF',
  width: '100%',
  overflow: 'visible',
  height: 'auto',
}));


const LocationList = (props) => {
  const {locations = [], instantApproval, listHover, setListHover, onlyLiveLocations = true, showDistance} = props;
  const {user} = useContext(AppContext);

  const [favoriteLocationIds, setFavoriteLocationIds] = React.useState(new Set());

  const generatePath = useCallback(function generatePath(location) {
    return generateLocationProfileLink(location.locationId, location.hasInstantApproval && instantApproval);
  }, [instantApproval]);

  useEffect(() => {
    if (isBuyerAccountType(user?.type)) {
      getAllBuyerFavoriteLocations().then((response) => {
        const favoriteIds = new Set(response.body.map(fav => fav.locationId));
        setFavoriteLocationIds(favoriteIds);
      }).catch((error) => {
        console.error('Error fetching favorite locations:', error);
      });
    }
  }, [user?.type]);

  return <LocationListContainer>
    {
      locations?.map(location =>
        <LocationListItemLink
          key={location.locationId}
          location={location}
          to={generatePath(location)}
          listHover={listHover}
          setListHover={setListHover}
          showVisibilityChip={!onlyLiveLocations}
          isFavorite={favoriteLocationIds.has(location.locationId)}
          showDistance={showDistance}
        />
      )
    }
  </LocationListContainer>
};

export default LocationList;
